import { mode } from '@chakra-ui/theme-tools';

export const tooltipStyles = {
  components: {
    Tooltip: {
      baseStyle: (props: any) => ({
        bg: mode('gray.800', 'gray.100')(props),
        color: mode('white', 'gray.800')(props),
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: '500',
        padding: '8px 12px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        maxWidth: '200px',
        zIndex: 1400,
        _arrow: {
          color: mode('gray.800', 'gray.100')(props),
        },
      }),
      variants: {
        // Custom variants for different tooltip styles
        brand: (props: any) => ({
          bg: mode('brand.500', 'brand.400')(props),
          color: 'white',
          _arrow: {
            color: mode('brand.500', 'brand.400')(props),
          },
        }),
        success: (props: any) => ({
          bg: mode('green.500', 'green.400')(props),
          color: 'white',
          _arrow: {
            color: mode('green.500', 'green.400')(props),
          },
        }),
        error: (props: any) => ({
          bg: mode('red.500', 'red.400')(props),
          color: 'white',
          _arrow: {
            color: mode('red.500', 'red.400')(props),
          },
        }),
        warning: (props: any) => ({
          bg: mode('orange.500', 'orange.400')(props),
          color: 'white',
          _arrow: {
            color: mode('orange.500', 'orange.400')(props),
          },
        }),
      },
      defaultProps: {
        variant: 'default',
      },
    },
  },
};
